var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg-icon',{staticClass:"w-2 h-2 inline-block ml-3",class:{'transform rotate-180 text-blue-900': _vm.sort === ("-" + _vm.name), 'text-blue-900': _vm.sort === _vm.name},attrs:{"name":"icons/sort"}})}
var staticRenderFns = []

export { render, staticRenderFns }